import { render, staticRenderFns } from "./NbaTopPlaysTable.vue?vue&type=template&id=d7fa92a2&scoped=true"
import script from "./NbaTopPlaysTable.vue?vue&type=script&lang=js"
export * from "./NbaTopPlaysTable.vue?vue&type=script&lang=js"
import style0 from "./NbaTopPlaysTable.vue?vue&type=style&index=0&id=d7fa92a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fa92a2",
  null
  
)

export default component.exports